export const permissionsActiveUsers = [
  "active-users",
  "everything-full",
  "everything-readonly",
];
